export default "__VITE_ASSET__de9c05e0__"